import axiosInstance from "@/api/axios-instance";

export interface MergeGroup {
  target_user_id: string;
  source_user_ids: string[];
}

export async function mergeDuplicateUsers(
  groups: MergeGroup[]
): Promise<{ merged: number }> {
  const response = await axiosInstance.post("/users/merge", { groups });
  return response.data;
}
